import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from '../login.service';
import { FlashMessagesService } from 'angular2-flash-messages';
import { INgxMyDpOptions, IMyDateModel } from 'ngx-mydatepicker';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs/Observable';
import { AutosuggestService } from '../autosuggest.service';
import { EventEmitter } from "@angular/core";
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';

@Component({
  selector: 'app-employee-report',
  templateUrl: './employee-report.component.html',
  styleUrls: ['./employee-report.component.css']
})
export class EmployeeReportComponent implements OnInit {
  dataSource;
  displayedColumns = ['sno', 'service_category', 'actions'];

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;


  columnNames = [{
    id: 'sno',
    value: 'S.No.',

  }, {
    id: 'service_category',
    value: 'Service Category',
  },
  {
    id: 'actions',
    value: 'Action',
  }
  ];



  @ViewChild('fileInput') fileInput;
  private appURL: string = environment.apiUrl;
  private uploadURL: string = environment.uploadUrl;
  public myFocusTriggeringEventEmitter = new EventEmitter<boolean>();
  myOptions: INgxMyDpOptions = {
    dateFormat: 'dd/mm/yyyy',
    disableSince: { year: new Date().getFullYear(), month: new Date().getMonth() + 1, day: new Date().getDate() + 1 }
    // This will disable dates starting from tomorrow
  };
  // Initialized to specific date (09.10.2018)
  model2: any = { date: { year: 2018, month: 10, day: 9 } };
  month1: any = {};
  wbetot_exp: any;
  mbetot_exp: any;
  model: any = {};
  user: any = {};
  results: any = {};
  currentUser: any = {};
  currentOrg: any;
  sessionData: any = {};
  searching = false;
  searchFailed = false;
  hideSearchingWhenUnsubscribed = new Observable(() => () => this.searching = false);
  certList: any = [];
  certificate: any = {};
  cert: any = {};
  contId: number;
  mask: any[] = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  tinmask: any[] = [/[0-9]/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
  certmask: any[] = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
  userType: number;
  showLoader: boolean;
  wbe_goal: number;
  mbe_goal: number;
  dataresult: any;
  overAll: any;
  constructor(
    private router: Router,
    private loginservice: LoginService,
    private Autosuggest: AutosuggestService,
    private _flashMessagesService: FlashMessagesService

  ) {
  }

  covenants: any = [
    { provinceID: 1 },
    { provinceID: 2 },
    { provinceID: 3 },
    { provinceID: 4 },
    { provinceID: 5 },
  ];

  openCoverages = false;
  indexSelectedCoverage = 1;
  onDateChanged(type, event: IMyDateModel): void {
  }

  ngOnInit(): void {
    this.currentUser = JSON.parse(this.loginservice.getLocalSession('currentUser'));
    // this.displayedColumns = this.columnNames.map(x => x.id);
    this.model['start_date'] = '';
    this.model['end_date'] = '';
    this.model['bill_no'] = '';


    const now = new Date();
    // Start date: 1st of current month
    const startDate = new Date(now.getFullYear(), now.getMonth(), 1);
    // End date: today
    const endDate = now;

    this.model.start_date = this.formatDateForPicker(startDate);
    this.model.end_date = this.formatDateForPicker(endDate);
    this.getemployeeList('');

    this.covenants.forEach((_covenants) => {
      _covenants.isExpanded = false;
    });
  }

  formatDateForPicker(dateObj: Date) {
    const year = dateObj.getFullYear();
    const month = dateObj.getMonth() + 1;
    const day = dateObj.getDate();

    return {
      date: { year: year, month: month, day: day },
      jsdate: dateObj.toISOString(),
      formatted: this.formatDDMMYYYY(day, month, year),
      epoc: Math.floor(dateObj.getTime() / 1000)
    };
  }

  formatDDMMYYYY(day: number, month: number, year: number): string {
    return this.pad(day) + '/' + this.pad(month) + '/' + year;
  }

  pad(n: number): string {
    return n < 10 ? '0' + n : n.toString();
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

  getemployeeList(datas) {

    if (datas.start_date) {

    } else {
      datas = {
        start_date: this.model['start_date'],
        end_date: this.model['end_date'],
        bill_no: this.model['bill_no'],
        // f_name: this.model['f_name'],
        // phone: this.model['phone'],
      };
    }

    this.loginservice.getemployeeList(datas, this.currentUser)
      .subscribe(
        data => {
          if (data['comp_details'].length > 0) {
            this.dataresult = data['comp_details'];
            this.overAll = data['overAll'];
            this.certList.contractorId = this.model['Id'];
            this.certList.uid = this.currentUser['uid'];
            this.certificate = data;
            this.showLoader = false;
            let tableArr: Element[] = data['comp_details'];
            this.dataSource = new MatTableDataSource(tableArr);
            this.dataSource.sort = this.sort;
            this.dataSource.paginator = this.paginator;
          } else {
            this.dataresult.length = 0;
            // this._flashMessagesService.show('No Subcontractors!', { cssClass: 'alert-danger' });
            // this.router.navigate(['addlowertier']);
            this.showLoader = false;
            let tableArr: Element[] = [];


            this.dataSource = new MatTableDataSource(tableArr);
            this.dataSource.sort = this.sort;
            this.dataSource.paginator = this.paginator;
          }
        },
        error => {
          alert('Network Error getemployeeList API');
          this.showLoader = false;
        });

  }

  search() {
    if (this.model['bill_no'] == '') {
      if (this.model['start_date'] == '' || this.model['end_date'] == '') {
        alert('Please Select Start & End Date & Bill No.');
        this._flashMessagesService.show('Please Select Start & End Date & Bill No.', { cssClass: 'alert-danger' });
        return true;
      }
    } else {
      if (this.model['start_date'] != '' && this.model['end_date'] == '') {
        alert('Please Select End Date');
        this._flashMessagesService.show('Please Select End Date', { cssClass: 'alert-danger' });
        return true;
      } else if (this.model['start_date'] == '' && this.model['end_date'] != '') {
        alert('Please Select Start Date');
        this._flashMessagesService.show('Please Select Start Date', { cssClass: 'alert-danger' });
        return true;
      }
    }
    let data = {
      start_date: this.model['start_date'],
      end_date: this.model['end_date'],
      bill_no: this.model['bill_no']
    };
    this.getemployeeList(data)
  }

  reset() {
    this.model['start_date'] = '';
    this.model['end_date'] = '';
    this.model['bill_no'] = '';
    this.ngOnInit();
  }



}







// WEBPACK FOOTER //
// ./src/app/employee-report/employee-report.component.ts